import React from "react";
import ReactModal from "react-modal";
import { Formik } from "formik";
import { Col, Form } from "react-bootstrap";
import "./add-sub-organization.scss";
import { saveSubOrganizations } from "../../../api";
import Loader from "../../loader/loader";

import * as yup from "yup";
const schema = yup.object({
    sub_org_name: yup.string().trim().required("* This filed is required"),
});
class AddSubOrganization extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isEdit: props.selectedMccRecord ? true : false,
            is_submitted: false,
            show_spinner: false,
            errorMessage: "",
            formData: {
                sub_org_name: props.sub_org_name ? props.sub_org_name : "",
            },
            errors: [],
        };
    }
    componentDidMount() {}
    updateChange(evt) {
        const targetName = evt.target.name;
        if (targetName === "") {
            return false;
        }
        let formData = this.state.formData;
        formData[targetName] = evt.target.value.trim();
        this.setState({ formData: formData, errorMessage: "" });
    }

    // add Edit data
    handleSaveSubOrg(evt) {
        this.setState({ show_spinner: true });
        const fromData = this.state.formData;

        const postData = {
            id: this.state.isEdit ? this.props.selectedMccRecord.id : null,
            sub_organization_name: fromData.sub_org_name,
            organization_id: this.props.organization_id,
        };
        saveSubOrganizations(postData)
            .then((res) => {
                if (res.status) {
                    this.props.openAddSubOrgModal(false);
                    this.props.getSubOrgs();
                } else {
                    this.setState({
                        show_spinner: false,
                        errorMessage: "Something wrong please try again.",
                    });
                }
            })
            .catch((err) => {
                if (err.status === 422) {
                    this.setState({
                        show_spinner: false,
                        errorMessage:
                            "Validation error! Please fill all required fields",
                    });
                } else {
                    this.setState({
                        show_spinner: false,
                        errorMessage: "Something wrong please try again.",
                    });
                }
            });
    }

    render() {
        const {
            isEdit,
            show_spinner,
            errorMessage,
            formData,
            errors,
            is_submitted,
        } = this.state;
        return (
            <ReactModal isOpen={this.props.show} className="add-sub-org-modal">
                <div className="modal-header">
                    <h4 className="text-left">
                        {isEdit
                            ? "Edit Sub Organization"
                            : "Add Sub Organization"}
                    </h4>
                </div>
                <div
                    onClick={() => this.props.openAddSubOrgModal(false)}
                    className="modal-cancel"
                >
                    <img src="/images/cancel.svg" />
                </div>
                <div className="modal-body">
                    <Formik
                        enableReinitialize
                        validationSchema={schema}
                        onSubmit={(e) => this.handleSaveSubOrg(e)}
                        initialValues={formData}
                        initialErrors={errors}
                        validateOnBlur={false}
                        validateOnChange={is_submitted}
                        validate={(values) => {
                            this.setState({ is_submitted: true });
                        }}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            values,
                            touched,
                            errors,
                        }) => (
                            <Form
                                id="add-edit-mcc-form"
                                onSubmit={handleSubmit}
                                onChange={(e) => this.updateChange(e)}
                                autoComplete="off"
                            >
                                <Form.Row>
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <Form.Control
                                            placeholder="Sub Organization Name"
                                            type="text"
                                            name="sub_org_name"
                                            value={
                                                values.sub_org_name
                                                    ? values.sub_org_name
                                                    : ""
                                            }
                                            onChange={handleChange}
                                            isInvalid={
                                                touched.sub_org_name &&
                                                !!errors.sub_org_name
                                            }
                                            isValid={
                                                is_submitted &&
                                                !errors.sub_org_name
                                            }
                                            className="preapp-form-input"
                                        />
                                        <label className="modal-lab">
                                            Sub Organization Name
                                        </label>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.sub_org_name}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Form.Row>
                            </Form>
                        )}
                    </Formik>
                </div>
                {show_spinner ? (
                    <div className="spinner">
                        <Loader />
                    </div>
                ) : (
                    ""
                )}
                <p className="error-message text-center">{errorMessage}</p>
                <div className="modal-footer">
                    <div className="button-twoc">
                        <button
                            form="add-edit-mcc-form"
                            type="submit"
                            className="btn confirm-button"
                        >
                            {" "}
                            {isEdit ? "Update" : "Add"}{" "}
                        </button>
                        <button
                            className="btn cancel-button"
                            onClick={() => this.props.openAddSubOrgModal(false)}
                        >
                            {" "}
                            Cancel{" "}
                        </button>
                    </div>
                </div>
            </ReactModal>
        );
    }
}

export default AddSubOrganization;
